import React from 'react';
import { Team } from '../../../backend/team';

type ProviderPropsT = {
  children: React.ReactNode;
};

type Initialized<T> = T | undefined;

type ContextPropsT = {
  team: Initialized<Team>;
  setTeam: React.Dispatch<React.SetStateAction<Team | undefined>>;
};

const TeamContext = React.createContext<ContextPropsT | undefined>(undefined);

TeamContext.displayName = 'TeamContext';

function TeamContextContextProvider({ children }: ProviderPropsT) {
  const [team, setTeam] = React.useState<Team>();
  const value = { team, setTeam };
  return <TeamContext.Provider value={value}>{children}</TeamContext.Provider>;
}

function useTeamContext() {
  const context = React.useContext(TeamContext);
  if (context === undefined) {
    throw new Error('useTeamContext must be used within a ClientProvider');
  }
  return context;
}

export { TeamContextContextProvider, useTeamContext };
